import { blue, green, red, amber, orange, lime, common, purple } from '@mui/material/colors'
import { AGING_BUCKET_NAME } from 'settings/constants/accountReceivables'

const {
  CURRENT,
  DUE_ONE_THIRTY,
  DUE_THIRTY_ONE_SIXTY,
  DUE_SIXTY_ONE_NINETY,
  DUE_OVER_NINETY,
  DUE_NINETY_ONE_ONE_TWENTY,
  DUE_OVER_ONE_TWENTY,
} = AGING_BUCKET_NAME

export const AGING_BUCKET_COLORS = {
  [CURRENT]: blue,
  [DUE_ONE_THIRTY]: lime,
  [DUE_THIRTY_ONE_SIXTY]: amber,
  [DUE_SIXTY_ONE_NINETY]: orange,
  [DUE_OVER_NINETY]: red,
  [DUE_NINETY_ONE_ONE_TWENTY]: red,
  [DUE_OVER_ONE_TWENTY]: purple,
}

export const AGING_BUCKET_TYPE_TO_QUERY_PARAM = {
  [CURRENT]: 'CURRENT',
  [DUE_ONE_THIRTY]: 'ONE_THIRTY',
  [DUE_THIRTY_ONE_SIXTY]: 'THIRTY_SIXTY',
  [DUE_SIXTY_ONE_NINETY]: 'SIXTY_NINETY',
  [DUE_OVER_NINETY]: 'OVER_NINETY', // Deprecated
  [DUE_NINETY_ONE_ONE_TWENTY]: 'NINETY_ONE_ONE_TWENTY',
  [DUE_OVER_ONE_TWENTY]: 'OVER_ONE_TWENTY',
}

export const ACCOUNT_CREDIT_COLOR = green

export const getBucketColorScheme = agingBucketName => {
  return agingBucketName in AGING_BUCKET_COLORS ? AGING_BUCKET_COLORS[agingBucketName] : ACCOUNT_CREDIT_COLOR
}

export const getBucketStyles = agingBucketName => {
  if (!agingBucketName) {
    return { borderColor: common.black }
  }

  const bucketColorScheme = getBucketColorScheme(agingBucketName)
  return { backgroundColor: bucketColorScheme[50], borderColor: bucketColorScheme[500] }
}
